
import { MechanicalAspectTypeInfoBase } from './mechanical-aspect.typeinfo.base';


export class MechanicalAspectTypeInfo extends MechanicalAspectTypeInfoBase {
}

export const MECHANICAL_ASPECT_TYPE: MechanicalAspectTypeInfo = new MechanicalAspectTypeInfo();



